<template>
  <div class="pc-note__sidebar-header" :class="{'no-border-bottom':noBorderBottom}" @click="toggleFoldedHandler">
    <span class="fold" v-if="canFold"><i :class="{'el-icon-arrow-down':!folded,'el-icon-arrow-right':folded}"/></span>
    <span class="name"><slot></slot></span>
    <div class="tools">
      <icon-ellipsis-h v-if="moreActions" ref="moreActions" title="更多操作..." @click="moreActionsHandler"/>
    </div>
  </div>
</template>

<script>
import IconEllipsisH from '@/components/icon/EllipsisH.vue'
import { mapMutations, mapGetters } from 'vuex'
import { createPopper } from '@popperjs/core'

export default {
  props: {
    name: {
      type: String,
      required: true
    },
    moreActions: {
      type: Object,
      default: null
    },
    canFold: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      noBorderBottom: false
    }
  },
  destroyed () {
  },
  components: {
    IconEllipsisH
  },
  computed: {
    ...mapGetters('workbench', {
      isFolded: 'isFolded'
    }),
    folded () {
      return this.isFolded(this.name)
    }
  },
  methods: {
    ...mapMutations('contextmenu', {
      setVisible: 'SET_VISIBLE',
      setType: 'SET_TYPE',
      setData: 'SET_DATA'
    }),
    ...mapMutations('workbench', {
      toggleFolded: 'TOGGLE_FOLDED'
    }),
    moreActionsHandler () {
      this.setVisible(true)
      this.setType(this.moreActions.contextmenu.type)
      this.setData(this.moreActions.contextmenu.data)
      this.$nextTick(() => {
        window.contextmenuPopper = createPopper(this.$refs.moreActions.$el, window.document.getElementById('pc-contextmenu'), {
          placement: 'bottom-start',
          strategy: 'fixed'
        })
      })
    },
    toggleFoldedHandler () {
      if (!this.canFold) {
        return
      }
      this.toggleFolded(this.name)
      this.noBorderBottom = this.name !== 'opened' && this.folded
    }
  }
}
</script>

<style lang="scss">
.no-border-bottom {
  border-bottom: none !important;
}
</style>
